var map = {
	"./Banner-BEV.png": 746,
	"./Contact-us.png": 657,
	"./Logo-BEV.png": 457,
	"./aluminium-bottles.png": 617,
	"./bottle-img-1.jpg": 816,
	"./bottle-img-2.jpg": 151,
	"./bottling-machine.png": 605,
	"./cans-imgs-1.jpg": 365,
	"./cans-imgs-2.jpg": 973,
	"./formulation-1.jpeg": 525,
	"./formulation-2.jpeg": 4,
	"./symbol-bev.png": 812,
	"./water-bottle.png": 198,
	"./wine-bottle-1.jpg": 740,
	"./wine-bottle-2.jpg": 187,
	"./wine-bottles.png": 419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;